// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qpk2","newExpiryDate":"styles_newExpiryDate__2OXAv","footer":"styles_footer__2cpqv"};